module.exports = __webpack_public_path__ + "img/shal.7cc89e7b.jpg";